/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col} from "react-bootstrap";


type SessionEndingLeftTime = {
    LEFT_SESSION_TIME: number
};


export const SessionEndingLeftTimeComponent: React.FC<SessionEndingLeftTime> = ({
    LEFT_SESSION_TIME = 0
}): JSX.Element | null => {



    let leftSessionMinutes: number | string = Math.floor(LEFT_SESSION_TIME / 60);
    let leftSessionSeconds: number | string = Math.floor(LEFT_SESSION_TIME % 60);

    if (leftSessionMinutes < 10) {
        leftSessionMinutes = `0${leftSessionMinutes}`;
    }

    if (leftSessionSeconds < 10) {
        leftSessionSeconds = `0${leftSessionSeconds}`;
    }

    return (
        <Col xs={12} className={"session-left-time-component session-left-time"}>

            <span className={"left-minutes"}>{leftSessionMinutes}</span>
            <span className={"separator"}>{`:`}</span>
            <span className={"left-seconds"}>{leftSessionSeconds}</span>

        </Col>
    );

};


export default SessionEndingLeftTimeComponent;
